import { images } from '@/asset';
import BoldLargeText from '@/components/BoldLargeText';
import MediumText from '@/components/MediumText';
import { Badge, Button, Page } from '@shopify/polaris';
import { memo } from 'react';
import { IProps, RuleTypeEnum } from '.';
import useGenerateCheckoutEditorLink from '@/hooks/useGenerateCheckoutEditorLink';
import { CheckIcon, ExternalIcon } from '@shopify/polaris-icons';
import { useSelector } from 'react-redux';
import { dataSettingsSelector } from '@/redux/slice/settings.slice';
const Step4 = (props: IProps) => {
  const dataSettings = useSelector(dataSettingsSelector);
  const isInCheckoutMode = props.ruleType === RuleTypeEnum.Checkout;
  const checkoutEditorInfo = useGenerateCheckoutEditorLink();
  return (
    <Page fullWidth>
      <div className="step-4">
        <div>
          <BoldLargeText alignment="center">
            {isInCheckoutMode ? 'Add app into Checkout' : 'Embed app and View on store'}
          </BoldLargeText>
          <div className="mt-8">
            <MediumText alignment="center">
              {isInCheckoutMode
                ? 'You can see preview but need to upgrade to activate the rule in store'
                : "Turn on app in App embeds. Make sure to click 'Save'."}
            </MediumText>
            {!isInCheckoutMode && <MediumText alignment="center">You can then see results on live store.</MediumText>}
            <div className="content-center mt-16 gap-12">
              {!isInCheckoutMode && props.isEmbedded && (
                <div className="d-flex align-center">
                  <Badge tone="success" icon={CheckIcon}>
                    App embedded
                  </Badge>
                </div>
              )}
              {isInCheckoutMode ? (
                <Button
                  icon={ExternalIcon}
                  variant="primary"
                  onClick={() => {
                    window.open(checkoutEditorInfo.link);
                  }}
                >
                  Open Checkout editor
                </Button>
              ) : (
                <Button
                  icon={ExternalIcon}
                  variant="primary"
                  onClick={() => {
                    window.open(
                      `https://${dataSettings.shop}.myshopline.com/admin/theme/editor/editing/ProductsDetail?themeId=${dataSettings.themeStoreId}&templateName=templates/product.json&activateAppId=${process.env.REACT_APP_THEME_APP_EXTENSION_ID}/app-embed-block`,
                      '_blank',
                    );
                  }}
                  disabled={props.isEmbedded}
                >
                  Activate
                </Button>
              )}
              <Button onClick={props.handleFinish}>{props.isEmbedded ? 'Done' : 'Got it, do later'}</Button>
            </div>
          </div>
        </div>

        <div className="mt-8 content-center">
          {isInCheckoutMode ? (
            <div className="add-checkout-block-container">
              <ol className="list-step">
                <li>Open Checkout editor</li>
                <li>
                  Select <b>Apps</b> in menu. Search <b>Synctrack Estimated Delivery Date</b>
                </li>
                <li>Add to desired pages</li>
              </ol>
              <img className="add-block-checkout-image" alt="add block checkout" src={images.addCheckoutApp} />
            </div>
          ) : (
            <img className="gif-image" alt="gif" src={images.embed_gif} />
          )}
        </div>
      </div>
    </Page>
  );
};

export default memo(Step4);
